import { CommonModule } from '@angular/common';
import { Component, inject, input, model, OnInit, signal, ViewChild, ProviderToken, Input, effect, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LocalizationModule, SubscriptionService } from '@abp/ng.core';
import { Language, TextTemplateSenderComponent } from '@digiwall/core-features';
import { BaseInvoiceDto, CustomerInvoiceService, PeppolSendStatus } from '@digiwall/goliath-documents/proxy';
import { CompanyService } from '@digiwall/goliath-core/proxy';
import { TextTemplateType } from '@digiwall/core/proxy';
import { FileInfoDto } from '@digiwall/file-management/proxy';
import { ToasterService } from '@abp/ng.theme.shared';

@Component({
  selector: 'document-peppol-text-template-sender',
  templateUrl: './peppol-text-template-sender.component.html',
  imports: [CommonModule, FormsModule, TextTemplateSenderComponent, LocalizationModule],
  providers: [SubscriptionService],

})
export class PeppolTextTemplateSenderComponent implements OnInit {
  private peppolService: CustomerInvoiceService = inject(CustomerInvoiceService);
  private companyService: CompanyService = inject(CompanyService);

  @ViewChild('textTemplateSender') public textTemplateSenderComponent!: TextTemplateSenderComponent;


  public entity = model<BaseInvoiceDto>();


  @Input() type: TextTemplateType;
  @Input() entityId: string;
  @Input() language: string = Language.French;
  @Input() recipients: string[];
  @Input() attachments?: FileInfoDto[];
  @Input() context: string;
  @Input() subContext: string;
  @Input() linkedEntities: Record<string, string>;

  protected sendByEmail = signal(false);
  protected sendToPeppol: boolean = false;
  protected generateUbl: boolean = false;
  protected isPeppolConfigurationEnabled: boolean = false;
  protected isThirdPartyElligible = computed(() =>
    this.entity().thirdPartyPeppolStatus === PeppolThirdPartyStatus.Eligible
  );

  constructor(private toaster: ToasterService) {}

  ngOnInit(): void {
    this.sendByEmail.set(this.entity().thirdPartyElectronicInvoice);
    this.companyService.isPeppolConfigurationEnabled().subscribeOnce(isEnabled => {
      this.isPeppolConfigurationEnabled = isEnabled;
      if (this.isPeppolConfigurationEnabled
        && this.entity().thirdPartyPeppolStatus == PeppolThirdPartyStatus.Eligible
        && (this.entity().peppolStatus == null || this.entity().peppolStatus == PeppolStatus.Invalid || this.entity().peppolSendStatus == PeppolSendStatus.Failure )) {
        this.sendToPeppol = true;
      } else {
        this.generateUbl =
          this.entity().thirdPartyPeppolStatus == PeppolThirdPartyStatus.Eligible &&
          (this.entity().peppolStatus == null ||
            this.entity().peppolStatus == PeppolStatus.NotGenerated);
      }
    });
  }

  protected afterSend(fileInfoDto: FileInfoDto[]) {
    if (this.sendToPeppol == true) {
      this.peppolService
        .sendToPeppol(this.entity().id, {
          sendUblToPeppol: this.sendToPeppol,
          generateUbl: this.generateUbl,
          fileIds: fileInfoDto?.map(f => f.id),
        })
        .subscribeOnce(() => {
          if (this.sendToPeppol || this.generateUbl) {
            let successTrKey: string;
            if (this.sendToPeppol) {
              successTrKey = 'Doc::PeppolUblSentSuccessfully';
            } else {
              successTrKey = 'Doc::PeppolUblGeneratedSuccessfully';
            }
            this.toaster.success(successTrKey);
          }
        });
    }
  }
}

enum PeppolStatus {
  NotGenerated = 'NotGenerated',
  Invalid = 'Invalid',
  Generated = 'Generated',
  Submitted = 'Submitted',
}

enum PeppolThirdPartyStatus {
  Unknown = 'Unknown',
  NotEligible = 'NotEligible',
  Eligible = 'Eligible',
}
